module.exports = __webpack_public_path__ + "static/TangleTower6-a42daf7ab5243469cd8d3b4cd005f161.png";